export enum $falsePositiveError {
  scanId = 'scanId',
  userId = 'userId',
  scanUrl = 'scanUrl',
  auditType = 'auditType',
  errorXPath = 'errorXPath',
  ruleId = 'ruleId',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
  digitalProperty = 'digitalProperty',
  urlHash = 'urlHash',
  reason = 'reason',
  flaws = 'flaws',
  tenantId = 'tenantId',
}
